import { type NuxtAxiosInstance } from "@nuxtjs/axios";

import { useApi } from "@/utils/api";

export default function useSearchAssistanceServiceApi($axios: NuxtAxiosInstance) {
  const baseUrl = "/v2";
  const _api = useApi({ name: "searchAssistanceService", url: baseUrl, $axios });

  async function fetchAutocompleteResults(data: PostSearchAutocompleteRequest) {
    return await _api.request<PostSearchAutocompleteResponse>({
      url: `${baseUrl}/autocomplete`,
      method: "POST",
      data,
    });
  }

  return { fetchAutocompleteResults };
}
